<template>
  <body id="appBody">
    <router-view></router-view>
  </body>
</template>

<script>
import { useUserStore } from '@/store/user'

//import axios from 'axios'
//axios.defaults.baseURL = "http://localhost:8080/"

export default {
  data() {
    return {

    }
  },
  computed: {
    onDashboard: function () {
      return this.$route.path.includes('dashboard')
    },
    onWidget: function () {
      return this.$route.path.includes('/widget')
    }
  },
  
  beforeMount() {
    const store = useUserStore()
    store.initializeStore()
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');
@import '@/assets/styles/utilities.scss';

body,
html {
  padding: 0px;
  margin: 0px;
  min-height: 100%;
}

#app {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  

}

.seen-page {
  background: linear-gradient(135deg, #0a0f24 0%, #121a38 100%);
  background-repeat: no-repeat;
  background-attachment: fixed;
  color: white;
  max-width: 100%;
  min-height: 100vh;
  width: 100vw;
}

/* Custom Scrollbar Styles */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: rgba(26, 35, 70, 0.5);  /* Matches the sidebar gradient start color */
  border-radius: 8px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(to bottom, #3b82f6, #2563eb);  /* Matches your blue accent colors */
  border-radius: 8px;
  border: 2px solid rgba(26, 35, 70, 0.5);
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(to bottom, #60a5fa, #3b82f6);
}

/* Firefox scrollbar styles */
* {
  scrollbar-width: thin;
  scrollbar-color: #3b82f6 rgba(26, 35, 70, 0.5);
}
</style>
